export default {
  trendsLoaded(state) {
    state.isTrendsLoaded = true;
  },
};
